export const environment = {
  production: false,
  env:'Testing',
  HomeTitle:'Clavis Utilitarios - Testing environment',
  ApiUrl: 'https://cltoolsapitest.clavisco.com/',
  recatpchaSiteKey: '6LcEL_EpAAAAAIvuGfcTDMcVd-DZhRdERKZ3HsB-',
  LogRocketId: ''
};
